/**
 * Group messages arrive as MUC/Sub events wrapping the real groupchat:
 *
 * ```
    <message from="g-41ef6e60@conference.skunk_works" to="32808@skunk_works">
      <delay xmlns="urn:xmpp:delay" stamp="2026-08-25T09:55:47Z"/>
      <event xmlns="http://jabber.org/protocol/pubsub#event">
        <items node="urn:xmpp:mucsub:nodes:messages">
          <item id="1787637921970855">
            <message from="g-41ef6e60@conference.skunk_works/32809"
                     to="32808@skunk_works" type="groupchat" xmlns="jabber:client">
              <origin-id xmlns="urn:xmpp:sid:0" id="g-1787637921960"/>
              <body>Hello from the MUC room !</body>
            </message>
 * ```
 *
 * https://docs.ejabberd.im/developer/xmpp-clients-bots/extensions/muc-sub/#receiving-events
 */

import type { Element as XmlEl } from "@xmpp/xml"
import {
  MUCSUB_MESSAGES_NODE,
  NS_CLIENT,
  NS_DELAY,
  NS_PUBSUB_EVENT,
} from "../../constants"
import { attr, hoist } from "../../xmlUtils"

/** The nested message, or null when this isn't a MUC/Sub wrapper. */
export function unwrapMucsub(xml: XmlEl): XmlEl | null {
  const pubsubEvent = xml.getChild("event", NS_PUBSUB_EVENT)
  if (!pubsubEvent) return null

  const items = pubsubEvent.getChild("items")
  if (attr(items, "node") !== MUCSUB_MESSAGES_NODE) return null

  const item = items?.getChild("item")
  if (!item) return null

  const message = item.getChild("message", NS_CLIENT)
  if (!message) return null

  // mod_offline stamps the WRAPPER and the stamp never reaches inside, so
  // dropping the envelope dates every queued message to reconnect time.
  hoist(xml, message, "delay", NS_DELAY)

  return message
}
